import React from 'react';
import { getModalPrivacy } from '../commons/helpers';
import { useDomainName } from '../commons/hooks';
import './Footer.css';

export const Footer = () => {
  const domainName = useDomainName();
  return (
    <span className='subtext'>
      Copyright©{domainName} All rights reserved.{' '}
      <a href='#!' onClick={getModalPrivacy}>
        Privacy Policy
      </a>
    </span>
  );
};
